import type { SelectiveExpansionTranslations } from "../en/SelectiveExpansion";
import type { TranslationShape } from "../../store/types";

export const selectiveExpansionEs: TranslationShape<SelectiveExpansionTranslations> = {
  loading: "Cargando recomendaciones…",
  loadError: "No se pudieron cargar las recomendaciones.",
  noRecommendations: "Ninguna recomendación coincide con estos filtros.",
  noAssignments: "No hay asignaciones de tiendas.",
  pagination: "Páginas de recomendaciones",
  previousPage: "Página anterior",
  nextPage: "Página siguiente",
  recommendationsTable: "Recomendaciones de expansión selectiva",
  assignmentsTable: "Asignaciones de tiendas",
  expand: "Mostrar asignaciones de tiendas",
  collapse: "Ocultar asignaciones de tiendas",
  category: "Categoría",
  rank: "Posición",
  itemCode: "Código del artículo",
  itemName: "Nombre del artículo",
  currentStores: "Tiendas actuales",
  recommendedStores: "Tiendas recomendadas",
  confidence: "Confianza",
  forecast: "Oportunidad prevista de 7 días",
  priorityScore: "Puntuación de prioridad",
  suppressionReason: "Motivo de exclusión",
  store: "Tienda",
  item: "Artículo",
  eligible: "Elegible",
  yes: "Sí",
  no: "No",
  reasons: {
    sku_not_ranged: "SKU no incluido",
    sku_already_ranged: "SKU ya incluido",
    pog_unresolved: "Planograma sin resolver",
    upc_unmapped: "Mapeo del artículo no disponible",
    job_missing: "Falta el trabajo de tienda",
    configured_exclusion: "Exclusión configurada",
  },
};
